import { render, staticRenderFns } from "./YinDaoYe.vue?vue&type=template&id=58635c34&scoped=true"
import script from "./YinDaoYe.vue?vue&type=script&lang=js"
export * from "./YinDaoYe.vue?vue&type=script&lang=js"
import style0 from "./YinDaoYe.vue?vue&type=style&index=0&id=58635c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58635c34",
  null
  
)

export default component.exports